import { Table } from "reactstrap";
import { H6, P, SVG } from "../../../../AbstractElements";
import { livePricesTableData } from "../../../../Data/Dashboard/CryptoDashboard/CryptoDashboard";
import ReactApexChart from "react-apexcharts";

const LivePricesTable = () => {
  return (
    <div className="custom-scrollbar">
      <Table responsive className="display w-100">
        <tbody>
          {livePricesTableData.map((data, i) => (
            <tr key={i}>
              <td>
                <div className="d-flex gap-2">
                  <div className="flex-shrink-0">
                    <SVG className="animation" iconId={data.icon} />
                  </div>
                  <div className="flex-grow-1">
                    <H6 className="f-w-600">{data.title}</H6>
                    <P>{data.coin}</P>
                  </div>
                </div>
              </td>
              <td>
                <ReactApexChart options={data.chart} series={data.chart.series} type={data.chart.chart?.type} height={15} />
              </td>
              <td>
                <div className="flex-grow-1">
                  <H6 className="f-w-600">{data.amount}</H6>
                  <P>{data.percentage}</P>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default LivePricesTable;
